import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
// import Layout from '@/components/layout'
import LayoutTop from '@/components/layouttop'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'// Progress 进度条样式

// const _import = require('./_import_' + process.env.NODE_ENV);
const _import = require('./_import_production');
// console.log(process.env.NODE_ENV);

Vue.use(VueRouter)

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [
  { path: '/', redirect: '/printandship' },
  {
    path: '/auth',
    name: 'auth',
    component: _import('/auth'),
  },
  {
    path: '/login',
    name: 'login',
    component: _import('/login'),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/printandship',
    name: 'printandship',
    component: LayoutTop,
    children: [
      {
        path: "",
        component: _import("/printandship/index"),
      }
    ]
  },
  {
    path: '/freeprint',
    name: 'freeprint',
    component: LayoutTop,
    children: [
      {
        path: "",
        component: _import("/freeprint/index"),
      }
    ]
  },
  {
    path: '/actionlog',
    name: 'actionlog',
    component: LayoutTop,
    children: [
      {
        path: "",
        component: _import("/actionlog/index"),
      }
    ]
  },
  {
    path: '/setting',
    name: 'setting',
    component: LayoutTop,
    children: [
      {
        path: "",
        component: _import("/setting/index"),
      }
    ]
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.name == "login" || to.name == "auth") {
    next()
  } else {
    /* 判断是否有已登录 */
    if (localStorage.getItem("token") ? true : false) {
      store.dispatch("dataMasking");
      store.dispatch("setMallList");
      store.dispatch("getPageCode").then(res => {
        next();
        NProgress.done();
      });
    } else {
      next('/auth')
      if (from.path == "/auth") {
        NProgress.done()
      }
    }
  }
})

router.afterEach((to, from) => {
  NProgress.done()
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' | ' + store.state.sys.title
  } else {
    document.title = store.state.sys.title
  }
})

export default router
